import React from 'react';
import pulseIcon from '../../../assets/pulse.png';

/**
 * PulseIcon Component
 * Renders a solid red heart icon if pulse is normal (within schedule target range).
 * Renders the original heart-with-arrow image (pulse.png) if pulse is abnormal (outside target range).
 *
 * @param {boolean} isAbnormal - Whether the pulse reading is abnormal (outside schedule target range)
 * @param {number} size - Icon width and height in px (default: 14)
 * @param {string} className - Optional CSS class name
 * @param {object} style - Optional inline styles
 */
const PulseIcon = ({ isAbnormal = false, size = 14, className = '', style = {} }) => {
  const baseStyle = {
    display: 'inline-block',
    verticalAlign: 'middle',
    marginLeft: '3px',
    marginRight: '2px',
    flexShrink: 0,
    width: `${size}px`,
    height: `${size}px`,
    objectFit: 'contain',
    ...style
  };

  if (isAbnormal) {
    // Render the exact original heart-with-arrow image asset for abnormal pulse
    return (
      <img
        src={pulseIcon}
        alt="Abnormal pulse"
        title="Abnormal Pulse"
        className={`pulse-icon-img pulse-icon-abnormal ${className}`}
        style={baseStyle}
      />
    );
  }

  // Render solid red heart SVG for normal pulse
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="#e63946"
      xmlns="http://www.w3.org/2000/svg"
      className={`pulse-icon-svg pulse-icon-normal ${className}`}
      style={baseStyle}
      aria-label="Normal pulse"
      title="Normal Pulse"
    >
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
    </svg>
  );
};

export default PulseIcon;
